import React from 'react';
import PropTypes from 'prop-types';

export default function ProfileLogo({ logo, children, altText }) {
    return (
        <div className="flex items-baseline">
            <img alt={altText} className="profile-logo" src={logo} />
            {children}
        </div>
    );
}

ProfileLogo.propTypes = {
    logo: PropTypes.string.isRequired,
    altText: PropTypes.string.isRequired,
    children: PropTypes.element,
};
